import { observable, action } from 'mobx';

export default class NotesStore {
  @observable notes = [];
  @observable filters = { status: '', search: '' };

  constructor(notesService) {
    this.notesService = notesService;
  }

  updateFilters({ search }) {
    this.filters.search = search;
    this.fetchNotes();
  }

  @action
  resetNotes() {
    this.notes = [];
  }

  @action
  async fetchNotes() {
    const result = await this.notesService.fetchNotes(this.filters);

    if (result) {
      this.notes = result.data;
    }
  }

  @action
  async createNote(
    toEmail,
    toName,
    body) {
    const result = await this.notesService.createNote( toEmail, toName, body);

    if (result) {
      this.notes.push(result.data);
    }
  }

  @action
  async deleteNote(uuid) {
    const idx = this.notes.findIndex(note => note.uuid === uuid);
    await this.notesService.deleteNote(uuid);
    this.notes.splice(idx, 1);
  }

  @action
  async updateNote(uuid, toEmail, toName, body) {
    const note = this.notes.find(note => note.uuid === uuid);
    await this.notesService.updateNote(uuid, toEmail, toName, body);
    note.toEmail = toEmail;
    note.toName = toName;
    note.body = body;
  }

  @action
  async getPaymentPlan() {
    const payment = await this.notesService.getPaymentPlan();
    return payment;
  }

  @action
  async cancelSubscription(dontSendNotes) {
    await this.notesService.cancelSubscription(dontSendNotes);
    return;
  }
}
